import Vue from 'vue'
import App from './App.vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueRouter from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import VueSilentbox from 'vue-silentbox'
import {VueMasonryPlugin} from 'vue-masonry'
import WOW from 'wow.js/dist/wow.js'
import VueMeta from 'vue-meta'
import VueApollo from 'vue-apollo'
import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { createHttpLink } from 'apollo-link-http'
import 'bootstrap/dist/css/bootstrap.css'
import '../src/assets/css/fontawesome-all.min.css'
import 'animate.css/animate.min.css'
import '../src/assets/scss/style.scss'
import 'slick-carousel/slick/slick.css'
import 'swiper/css/swiper.css'
import '@/libs/sweet-alerts'
import { routes } from './router/index'

Vue.use(VueMasonryPlugin)
Vue.use(VueSilentbox)
Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(VueAwesomeSwiper)
Vue.use(VueMeta, {
    refreshOnceOnNavigation: true
})


Vue.config.productionTip = false
Vue.config.productionSourceMap = false
Vue.use(VueApollo)

// HTTP connection to the API
const httpLink = createHttpLink({
    // You should use an absolute URL here
    uri: 'https://api-forum.progrentis.com/graphql',
    // uri: 'http://localhost:4000/',
  
  })
  
  // Cache implementation
  const cache = new InMemoryCache()
  
  // Create the apollo client
  const apolloClient = new ApolloClient({
    link: httpLink,
    cache,
  })
  
  Vue.use(VueApollo)
  
  const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
  })




const router = new VueRouter({
    routes,
    mode: 'history'
})


new Vue({
    apolloProvider,
    render: h => h(App),
    router,
    mounted(){
        new WOW().init();
    }
}).$mount('#app')
